"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axios = void 0;
const axios_1 = __importDefault(require("axios"));
const jwt_decode_1 = __importDefault(require("jwt-decode"));
class Axios {
    constructor() {
        this.isRetrying = false;
        this.accessToken = null;
        this.setAuthorization = (accessToken) => {
            if (accessToken)
                this.instance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
            else
                delete this.instance.defaults.headers.common.Authorization;
            this.accessToken = accessToken;
        };
        this.instance = axios_1.default.create({
            timeout: 10000,
            headers: {
                "X-Timezone-Offset": String(new Date().getTimezoneOffset())
            }
        });
        /*this.instance.interceptors.response.use(response => {
          return response
        }, async (error) => {
          if (error.response.status === 401) {
            if (!this.isRetrying) {
              this.isRetrying = true
              // Retry
              await auth.refresh()
              const success = this.hasValidAccessToken()
              this.isRetrying = false
              if (!success) {
                this.setAuthorization(null)
                return Promise.reject(error)
              }
              else {
                // Relaunch the call with the new token
                error.config.headers.Authorization = `Bearer ${this.accessToken}`
                return axiosLibrary.request(error.config)
              }
            }
            this.setAuthorization(null)
            return Promise.reject(error)
          }
          return Promise.reject(error)
        })*/
    }
    setBaseUrl(baseURL) {
        this.instance.defaults.baseURL = baseURL;
    }
    async get(url, config) {
        return this.instance.get(url, config);
    }
    post(url, data, config) {
        return this.instance.post(url, data, config);
    }
    delete(url, config) {
        return this.instance.delete(url, config);
    }
    patch(url, data, config) {
        return this.instance.patch(url, data, config);
    }
    hasValidAccessToken() {
        if (!this.accessToken)
            return false;
        const decoded = (0, jwt_decode_1.default)(this.accessToken);
        if (!decoded.exp)
            return false;
        return decoded.exp * 1000 >= Date.now();
    }
}
exports.axios = new Axios();
